import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SearchOutlined } from "@ant-design/icons";
import useInlineEditBuffer from "@tailormed/common-client/component/inline-edit/hooks/useInlineEditBuffer";
import AssigneesSelectField from "@tailormed/common-client/component/Select/AssigneesSelectField";

import { selectAssigneesAndUserGroups, selectUser } from "../../../store/selector";
import getInlineEditPopupContainer from "@tailormed/common-client/component/inline-edit/getInlineEditPopupContainer";

const toStringIds = (arr = []) => arr.map((v) => String(v));

const PatientAssigneeInlineEditor = ({ value, onCommit, onCancel, autoFocus = true }) => {
  const { t } = useTranslation();
  const assignees = useSelector(selectAssigneesAndUserGroups);
  const user = useSelector(selectUser);

  const initialIds = toStringIds(Array.isArray(value) ? value : value ? [value] : [])
    .map((id) => (assignees || []).find((a) => a && a.id != null && a.id.toString() === id))
    .filter(Boolean)
    .sort((a, b) => (a.displayName || "").localeCompare(b.displayName || ""))
    .map(({ id }) => String(id));
  const { buffer, setBuffer, handleBlur, handleKeyDown } = useInlineEditBuffer({
    value: initialIds,
    onCommit,
    onCancel
  });

  return (
    <AssigneesSelectField
      assignees={assignees}
      currentUser={user}
      currentUserSuffix={t("bulk_actions.current_user_suffix")}
      placeholder={t("inline_edit.assignee_placeholder")}
      value={buffer}
      onChange={setBuffer}
      autoFocus={autoFocus}
      defaultOpen={autoFocus}
      suffixIcon={<SearchOutlined />}
      maxTagCount="responsive"
      maxTagPlaceholder={(omitted) => `+${omitted.length}`}
      bordered
      dropdownMatchSelectWidth={false}
      dropdownStyle={{ minWidth: 280, maxHeight: 240, overflowY: "auto" }}
      getPopupContainer={getInlineEditPopupContainer}
      style={{ width: "100%", minWidth: 140 }}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    />
  );
};

PatientAssigneeInlineEditor.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  onCommit: PropTypes.func,
  onCancel: PropTypes.func,
  autoFocus: PropTypes.bool
};

export default PatientAssigneeInlineEditor;
